import { MetricPeriod } from '@csp/csp-common-model';
import {
  GenericRequest,
  ScheduleCode,
  ScheduleValidationService,
  ScheduleVersionInfo,
} from '@csp/csp-common-scheduling';
import { DeviceModelNumberType } from '@csp/device-catalog';
import { DeviceObservationRequestV1 } from '@csp/dmdp-api-device-dto';
import { DeviceObservationRequestDetails } from './DeviceObservationRequestDetails';
import { DeviceObservationRequestInfo } from './DeviceObservationRequestInfo';

export type DeviceObservationRequest = GenericRequest & {
  versionInfo: ScheduleVersionInfo;
  details: DeviceObservationRequestDetails;
  referencedModelNumbers: DeviceModelNumberType[];
  historicalMetricPeriod?: MetricPeriod;
  isGroupedByScheduleCode?: boolean;
};

const from = (
  scheduleCode: ScheduleCode,
  versionInfo: ScheduleVersionInfo,
  requestV1: DeviceObservationRequestV1,
): DeviceObservationRequest => {
  const request: DeviceObservationRequest = {
    ...DeviceObservationRequestInfo.from(scheduleCode, versionInfo.versionCode, requestV1),
    versionInfo,
  };

  ScheduleValidationService.validateRequest(request);
  return request;
};

export const DeviceObservationRequest = {
  from,
};
